import React from "react";

export default function PDFconverter() {
  return (
    <section className="flex w-screen h-screen items-center justify-center">
      <h1>Coming Soon</h1>
    </section>
  );
}
